import { render, staticRenderFns } from "./freeCreditManualAssign.vue?vue&type=template&id=1f5ce44c&lang=pug"
import script from "./freeCreditManualAssign.vue?vue&type=script&lang=js"
export * from "./freeCreditManualAssign.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports